<div class="spinner" *ngIf="isVisible">
	<div class="spinner__text">Loading</div>
</div>